import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import lo from 'lodash';
import { NewWaitingTugBarge } from 'fixtures/TemplateData';
import DataTable from 'components/organisms/DataTable/index';
import ButtonReg from 'components/atoms/Buttons/Button';
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter';
import { EditFormater } from 'components/molecules/TableFormatters/editFormatter';
import { getLookup } from 'Redux/actions/LookupActions';
import { dateTimePickerFormatter } from 'components/molecules/TableFormatters/dateTimePickerFormatter';
import moment from 'moment'
export class ActualLoadingWaitingTugboatBargeForm extends Component {
  onChange(val, row, field, rowIndex) {
    const { form: { waitingTugboatBarge }, onChange } = this.props
    const newData = waitingTugboatBarge.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : field === 'arrivalJetty' ? moment(val).format() : val
    } : d)
    onChange('waitingTugboatBarge', newData)
  }

  add() {
    const { form: { waitingTugboatBarge }, onChange } = this.props
    const newData = [...waitingTugboatBarge, lo.cloneDeep(NewWaitingTugBarge)]
    onChange('waitingTugboatBarge', newData)
  }

  delete(row, rowIndex) {
    const { form: { waitingTugboatBarge }, onChange } = this.props
    const newData = waitingTugboatBarge.filter((d,i) => i !== rowIndex)
    onChange('waitingTugboatBarge', newData)
  }

  render() {
    const { viewState: { isMobileView }, form: { waitingTugboatBarge } } = this.props

    const config = [
      {
        dataField: 'tugboatBarge',
        text: 'Tugboat/Barge',
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter tugboat/barge',
          type: 'text',
          field: 'tugboatBarge',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'planCargoQuality',
        text: 'Plan Cargo & Quality',
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter plan cargo & quality',
          type: 'text',
          field: 'planCargoQuality',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'arrivalJetty',
        text: 'Arrival Jetty',
        formatter: dateTimePickerFormatter,
        formatExtraData: {
          placeholder: 'Enter tugboat/barge',
          field: 'arrivalJetty',
          fn: (val, row, field, rowIndex) => this.onChange(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { minWidth: 100 },
        formatter: actionFormatter,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowDel: true,
          del: (row, rowIndex) => this.delete.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true
      },
    ]

    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Waiting Tugboat/Barge
              </Label>
            </HeadContainer>
              <LevelRowContainer>
                <DataTable
                  leftSlot={
                    <ButtonReg
                      btnTxt={'Add'}
                      onClick={() => this.add()}
                      width={'78px'}
                    />
                  }
                  allowSearch={false}
                  rightSlotAlt={true}
                  defaultSize={100}
                  isMobile={isMobileView}
                  dataList={waitingTugboatBarge || []}
                  columnConfig={config}
                />
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingWaitingTugboatBargeForm)
  )
);
